$(function () {
  $(document).on("click", ".slidecarthq button", function () {
    setTimeout(function () {
      $("body").css("overflow", "auto");
    }, 200);
  });

  /*
   * altbased functionality
   */

  $(".main_images_slide").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: ".thumb_image_slider",
    prevArrow:
      '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
  });

  $(".thumb_image_slider").slick({
    infinite: true,
    slidesToShow: 4,
    variableWidth: true,
    slidesToScroll: 1,
    asNavFor: ".main_images_slide",
    dots: false,
    arrows: true,
    focusOnSelect: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
  });

  var options1 = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: ".thumb_image_slider",
    dots: false,
    focusOnSelect: true,
    // verticalSwiping:true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
  };

  var options2 = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    //mobileFirst:true,
    asNavFor: ".main_images_slide",
    focusOnSelect: true,
    variableWidth: true,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></button>',
  };

  // var popuHtml = "";
  // $(".zoom_btns").on("click", function () {
  //   $(".cstm_productslidepopup")
  //     .children(".inner_popup")
  //     .find(".popup_slider_prd")
  //     .html("");
  //   var innerzoomImg = $(".inner_main_slide");
  //   innerzoomImg.each(function () {
  //     popuHtml += '<div class="inner_popu">' + $(this).html() + "</div>";
  //     $(".cstm_productslidepopup").css("display", "block");
  //   });
  //   console.log(popuHtml);
  //   $(".cstm_productslidepopup")
  //     .children(".inner_popup")
  //     .find(".popup_slider_prd")
  //     .html(popuHtml);
  //   $(".popup_slider_prd").slick(options1);
  // });

  // $(".cstm_close").on("click", function () {
  //   $(".cstm_productslidepopup").css("display", "none");
  //   $(".popup_slider_prd").slick("unslick");
  // });

  // $(".styled-select").on("change", function () {
  //   var clrImg = $(this).find(":selected").attr("data-url");
  //   var clrsmall = $(this).find(":selected").attr("data-surl");

  //   var selectedVal = $(this).find(":selected").val();
  //   var newVal = selectedVal
  //     .toLowerCase()
  //     .replace(/[^a-z0-9]+/g, "-")
  //     .replace(/-$/, "")
  //     .replace(/^-/, "");
  //   // if alt tags
  //   var finalImages = $(".cstm_product_imgaes").children("." + newVal);
  //   var lwrImages = $(".cstmthumb_image_slider").children("." + newVal);

  //   // if no alt tags
  //   var nofinalImages = $(".cstm_product_imgaes").children("div");
  //   var nolwrImages = $(".cstmthumb_image_slider").children("div");

  //   var sliderHtml1 = "";
  //   var sliderHtml2 = "";

  //   finalImages.each(function () {
  //     console.log($(this).attr("src"));
  //     sliderHtml1 +=
  //       "<div class='inner_main_slide'>" + $(this).html() + "</div>";
  //   });

  //   lwrImages.each(function () {
  //     console.log($(this).attr("src"));
  //     sliderHtml2 +=
  //       "<div class='thumb_main_slide'>" + $(this).html() + "</div>";
  //   });
  //   console.log(sliderHtml1);
  //   if (sliderHtml1 != "") {
  //     $(".main_images_slide").html("");
  //     $(".thumb_image_slider").html("");

  //     $(".main_images_slide").slick("unslick");
  //     $(".thumb_image_slider").slick("unslick");

  //     $(".main_images_slide").html(sliderHtml1);
  //     $(".thumb_image_slider").html(sliderHtml2);

  //     $(".main_images_slide").slick(options1);
  //     $(".thumb_image_slider").slick(options2);
  //   } else {
  //     nofinalImages.each(function () {
  //       sliderHtml1 +=
  //         "<div class='inner_main_slide'><img class='cstm_productimg' src=" +
  //         clrImg +
  //         "></div>";
  //       sliderHtml1 +=
  //         "<div class='inner_main_slide'>" + $(this).html() + "</div>";
  //     });

  //     nolwrImages.each(function () {
  //       sliderHtml2 +=
  //         "<div class='thumb_main_slide'><img src=" + clrsmall + "></div>";
  //       sliderHtml2 +=
  //         "<div class='thumb_main_slide'>" + $(this).html() + "</div>";
  //     });

  //     $(".main_images_slide").html("");
  //     $(".thumb_image_slider").html("");

  //     $(".main_images_slide").slick("unslick");
  //     $(".thumb_image_slider").slick("unslick");

  //     $(".main_images_slide").html(sliderHtml1);
  //     $(".thumb_image_slider").html(sliderHtml2);

  //     $(".main_images_slide").slick(options1);
  //     $(".thumb_image_slider").slick(options2);
  //   }
  // });

  // onload function

  // $(window).on("load", function () {
  //   setTimeout(function () {
  //     $(".cstm_collecto :selected").each(function (i, sel) {
  //       var cstmload = $(sel).val();
  //       var clrImg2 = $(this).find(":selected").attr("data-url");
  //       if (cstmload != "Select a Device") {
  //         var currUrl = $(sel).attr("data-url");

  //         // $(this).parents(".span-3").find("a").attr("href", currUrl);
  //         var colnewVal = cstmload
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsrc = $(this)
  //           .parents(".span-3")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal)
  //           .attr("src");

  //         var secondImage = $(this)
  //           .parents(".span-3")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal + ":eq(1)")
  //           .attr("src");
  //         var secondImage1 = $(this)
  //           .parents(".span-3")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal + ":eq(0)")
  //           .attr("src");

  //         if (secondImage != undefined) {
  //           console.log("sec1" + secondImage1);
  //           var ccustmHTML = '<img src="' + secondImage + '"> ';
  //           $(this).parents(".span-3").find(".cstm_hidden").html(ccustmHTML);
  //           $(this)
  //             .parents(".span-3")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", secondImage1);
  //           $(this)
  //             .parents(".span-3")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", secondImage1);
  //           $(".cstm_mainimmg").css("display", "block");
  //           setTimeout(function () {
  //             $(".cstm_hidden").children("img").removeAttr("data-srcset");
  //             $(".cstm_hidden").children("img").removeAttr("srcset");
  //           }, 1000);
  //         } else {
  //           console.log("sec2" + secondImage);
  //           var cimgsrctext = $(this)
  //             .parents(".span-3")
  //             .find(".js-product-details-link")
  //             .children("h3")
  //             .text();
  //           var cimgsrctextvalas = cimgsrctext
  //             .toLowerCase()
  //             .replace(/[^a-z0-9]+/g, "-")
  //             .replace(/-$/, "")
  //             .replace(/^-/, "");
  //           var cimgsecondImage = $(this)
  //             .parents(".span-3")
  //             .find(".variants_hidedimgs")
  //             .find("." + cimgsrctextvalas + ":eq(1)")
  //             .attr("src");
  //           console.log("sec3" + cimgsrctextvalas);
  //           if (cimgsecondImage != undefined) {
  //             console.log("sec3" + cimgsrctextvalas);

  //             var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //             $(this)
  //               .parents(".span-3")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl);
  //           } else {
  //             console.log("sec31 find");
  //             var eleimg1 = $(this)
  //               .parents(".span-3")
  //               .find(".variants_hidedimgs")
  //               .children("img:eq(1)")
  //               .attr("src");
  //             console.log("sec31" + eleimg);
  //             var cimcustmHTMLl22 = '<img src="' + eleimg1 + '"> ';
  //             $(this)
  //               .parents(".span-3")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl22);
  //           }
  //         }
  //       } else {
  //         var cimgsrctext = $(this)
  //           .parents(".span-3")
  //           .find(".js-product-details-link")
  //           .children("h3")
  //           .text();
  //         var cimgsrctextval = cimgsrctext
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsecondImage = $(this)
  //           .parents(".span-3")
  //           .find(".variants_hidedimgs")
  //           .find("." + cimgsrctextval + ":eq(1)")
  //           .attr("src");

  //         if (cimgsecondImage != undefined) {
  //           console.log("sec5" + secondImage);
  //           var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //           $(this).parents(".span-3").find(".cstm_hidden").html(cimcustmHTMLl);

  //           $(this)
  //             .parents(".span-3")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", cimgsrc);
  //           $(this)
  //             .parents(".span-3")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", cimgsrc);
  //         } else {
  //           console.log("sec6" + secondImage);
  //           var eleimg = $(this)
  //             .parents(".span-3")
  //             .find(".variants_hidedimgs")
  //             .children("img:eq(1)")
  //             .attr("src");
  //           var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //           $(this)
  //             .parents(".span-3")
  //             .find(".cstm_hidden")
  //             .html(cimcustmHTMLl22);
  //         }
  //       }

  //       // alert(cstmload);
  //     });
  //   }, 2000);

  //   var cstmSelectbox = $(".option_dropdown_name_select-a-device")
  //     .find(".styled-select")
  //     .val();
  //   if (cstmSelectbox != undefined && cstmSelectbox != "") {
  //     var cstmOnloadVal = cstmSelectbox
  //       .toLowerCase()
  //       .replace(/[^a-z0-9]+/g, "-")
  //       .replace(/-$/, "")
  //       .replace(/^-/, "");

  //     var onfinalImages = $(".cstm_product_imgaes").children(
  //       "." + cstmOnloadVal
  //     );
  //     var onlwrImages = $(".cstmthumb_image_slider").children(
  //       "." + cstmOnloadVal
  //     );

  //     var onsliderHtml1 = "";
  //     var onsliderHtml2 = "";

  //     onfinalImages.each(function () {
  //       onsliderHtml1 +=
  //         "<div class='inner_main_slide'>" + $(this).html() + "</div>";
  //     });

  //     onlwrImages.each(function () {
  //       onsliderHtml2 +=
  //         "<div class='thumb_main_slide'>" + $(this).html() + "</div>";
  //     });

  //     if (onsliderHtml1 != "") {
  //       $(".main_images_slide").slick("unslick");
  //       $(".thumb_image_slider").slick("unslick");

  //       $(".main_images_slide").html(onsliderHtml1);
  //       $(".thumb_image_slider").html(onsliderHtml2);

  //       $(".main_images_slide").slick(options1);
  //       $(".thumb_image_slider").slick(options2);
  //     }
  //   }
  // });

  /*
   * if class exist
   */
  // var interval = setInterval(function () {
  //   if ($(".related-product-loop")[0]) {
  //     $(".cstm_collecto :selected").each(function (i, sel) {
  //       var cstmload = $(sel).val();
  //       var clrImg2 = $(this).find(":selected").attr("data-url");
  //       if (cstmload != "Select a Device") {
  //         var currUrl = $(sel).attr("data-url");

  //         $(this).parents(".product").find("a").attr("href", currUrl);
  //         var colnewVal = cstmload
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsrc = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal)
  //           .attr("src");

  //         var secondImage = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal + ":eq(1)")
  //           .attr("src");
  //         var secondImage1 = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVal + ":eq(0)")
  //           .attr("src");

  //         if (secondImage != undefined) {
  //           console.log("sec1" + secondImage1);
  //           var ccustmHTML = '<img src="' + secondImage + '"> ';
  //           $(this).parents(".product").find(".cstm_hidden").html(ccustmHTML);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", secondImage1);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", secondImage1);
  //           $(".cstm_mainimmg").css("display", "block");
  //           setTimeout(function () {
  //             $(".cstm_hidden").children("img").removeAttr("data-srcset");
  //             $(".cstm_hidden").children("img").removeAttr("srcset");
  //           }, 1000);
  //         } else {
  //           console.log("sec2" + secondImage);
  //           var cimgsrctext = $(this)
  //             .parents(".product")
  //             .find(".js-product-details-link")
  //             .children("h3")
  //             .text();
  //           var cimgsrctextvalas = cimgsrctext
  //             .toLowerCase()
  //             .replace(/[^a-z0-9]+/g, "-")
  //             .replace(/-$/, "")
  //             .replace(/^-/, "");
  //           var cimgsecondImage = $(this)
  //             .parents(".product")
  //             .find(".variants_hidedimgs")
  //             .find("." + cimgsrctextvalas + ":eq(1)")
  //             .attr("src");
  //           console.log("sec3" + cimgsrctextvalas);
  //           if (cimgsecondImage != undefined) {
  //             console.log("sec3" + cimgsrctextvalas);

  //             var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //             $(this)
  //               .parents(".product")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl);
  //           } else {
  //             console.log("sec31 find");
  //             var eleimg1 = $(this)
  //               .parents(".product")
  //               .find(".variants_hidedimgs")
  //               .children("img:eq(1)")
  //               .attr("src");
  //             console.log("sec31" + eleimg);
  //             var cimcustmHTMLl22 = '<img src="' + eleimg1 + '"> ';
  //             $(this)
  //               .parents(".product")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl22);
  //           }
  //         }
  //       } else {
  //         var cimgsrctext = $(this)
  //           .parents(".product")
  //           .find(".js-product-details-link")
  //           .children("h3")
  //           .text();
  //         var cimgsrctextval = cimgsrctext
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsecondImage = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + cimgsrctextval + ":eq(1)")
  //           .attr("src");

  //         console.log("c0" + cimgsecondImage);
  //         if (cimgsecondImage != undefined) {
  //           console.log("c1" + secondImage);
  //           var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_hidden")
  //             .html(cimcustmHTMLl);

  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", cimgsrc);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", cimgsrc);
  //         } else {
  //           console.log("c3" + secondImage);
  //           var eleimg = $(this)
  //             .parents(".product")
  //             .find(".variants_hidedimgs")
  //             .children("img:eq(1)")
  //             .attr("src");
  //           console.log("c3--" + eleimg);
  //           var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_hidden")
  //             .html(cimcustmHTMLl22);
  //         }
  //       }

  //       // alert(cstmload);
  //     });

  //     $(".reveal").hover(function () {
  //       $(this).toggleClass("collmain_active");
  //     });

  //     /*
  //      * altbased closed function
  //      */
  //     $(document).on("change", ".cstm_collecto", function () {
  //       var cstmcollval = $(this).find(":selected").val();
  //       var currUrl = $(this).find(":selected").attr("data-url");

  //       $(this).parents(".product").find("a").attr("href", currUrl);
  //       if (cstmcollval != "Select a Device") {
  //         console.log("1");
  //         var colnewVala = cstmcollval
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsrca = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVala)
  //           .attr("src");

  //         var secondImagea = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + colnewVala + ":eq(1)")
  //           .attr("src");

  //         if (secondImagea != undefined) {
  //           console.log("2");
  //           var ccustmHTMLa = '<img src="' + secondImagea + '"> ';
  //           $(this).parents(".product").find(".cstm_hidden").html(ccustmHTMLa);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", cimgsrca);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", cimgsrca);

  //           setTimeout(function () {
  //             $(".cstm_hidden").children("img").removeAttr("data-srcset");
  //             $(".cstm_hidden").children("img").removeAttr("srcset");
  //           }, 1000);
  //         } else {
  //           console.log("3");

  //           var cimgsrctext = $(this)
  //             .parents(".product")
  //             .find(".js-product-details-link")
  //             .children("h3")
  //             .text();
  //           var cimgsrctextval = cimgsrctext
  //             .toLowerCase()
  //             .replace(/[^a-z0-9]+/g, "-")
  //             .replace(/-$/, "")
  //             .replace(/^-/, "");
  //           //    alert(cimgsrctextval);
  //           var cimgsecondImage = $(this)
  //             .parents(".product")
  //             .find(".variants_hidedimgs")
  //             .find("." + cimgsrctextval + ":eq(1)")
  //             .attr("src");
  //           if (cimgsecondImage != undefined) {
  //             console.log("4");

  //             var cimcustmHTMLl = '<img src="' + cimgsecondImage + '">';
  //             $(this)
  //               .parents(".product")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl);
  //           } else {
  //             console.log("5");
  //             var eleimg = $(this)
  //               .parents(".product")
  //               .find(".variants_hidedimgs")
  //               .children("img:eq(1)")
  //               .attr("src");
  //             var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //             $(this)
  //               .parents(".product")
  //               .find(".cstm_hidden")
  //               .html(cimcustmHTMLl22);
  //           }
  //         }
  //       } else {
  //         console.log("6");
  //         var cimgsrctext = $(this)
  //           .parents(".product")
  //           .find(".js-product-details-link")
  //           .children("h3")
  //           .text();
  //         var cimgsrctextval = cimgsrctext
  //           .toLowerCase()
  //           .replace(/[^a-z0-9]+/g, "-")
  //           .replace(/-$/, "")
  //           .replace(/^-/, "");
  //         var cimgsecondImage = $(this)
  //           .parents(".product")
  //           .find(".variants_hidedimgs")
  //           .find("." + cimgsrctextval + ":eq(2)")
  //           .attr("src");

  //         //       var cimcustmHTMLl = '<img src="'+cimgsecondImage+'"> ';
  //         //    $(this).parents('.span-3').find('.cstm_hidden').html(cimcustmHTMLl);

  //         //    $(this).parents('.span-3').find('.cstm_mainimmgrnd').attr('data-srcset',cimgsrca);
  //         //    $(this).parents('.span-3').find('.cstm_mainimmgrnd').attr('srcset',cimgsrca);

  //         if (cimgsecondImage != undefined) {
  //           console.log("7");
  //           var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_hidden")
  //             .html(cimcustmHTMLl);

  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("data-srcset", cimgsrc);
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_mainimmgrnd")
  //             .attr("srcset", cimgsrc);
  //         } else {
  //           console.log("8");
  //           var eleimg = $(this)
  //             .parents(".product")
  //             .find(".variants_hidedimgs")
  //             .children("img:eq(1)")
  //             .attr("src");
  //           var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //           $(this)
  //             .parents(".product")
  //             .find(".cstm_hidden")
  //             .html(cimcustmHTMLl22);
  //         }
  //       }
  //     });

  //     $(".collection_select_options").change(function () {
  //       var possibles2 = [];
  //       $(this).find("option:first-child").attr("disabled", "disabled");
  //       var selectedDevice = $(this).find("option:selected").val();
  //       var selectedCase = $(this)
  //         .parents(".product-index")
  //         .find(".collection_swatches input:checked")
  //         .val();
  //       var selectedValues = selectedCase + " / " + selectedDevice;
  //       var varid = "";

  //       varid = $(this)
  //         .parents(".product_form")
  //         .find(
  //           '.hidden_dropdown_options option[value="' + selectedValues + '"]'
  //         )
  //         .attr("varid");
  //       var price = $(this)
  //         .parents(".product_form")
  //         .find(
  //           '.hidden_dropdown_options option[value="' + selectedValues + '"]'
  //         )
  //         .attr("reg_price");
  //       var varimg = $(this)
  //         .parents(".product_form")
  //         .find(
  //           '.hidden_dropdown_options option[value="' + selectedValues + '"]'
  //         )
  //         .attr("var_img");
  //       var reg_price = $(this)
  //         .parents(".product_form")
  //         .find(
  //           '.hidden_dropdown_options option[value="' + selectedValues + '"]'
  //         )
  //         .attr("reg_price");

  //       console.log(varid);
  //       if (typeof varid === "undefined") {
  //         $(this).removeClass("checked_option");
  //         $(this)
  //           .parents(".product_form")
  //           .find(".collectionAtc")
  //           .val("Unavailable")
  //           .attr("disabled", "disabled");
  //         $(this)
  //           .parents(".product-index")
  //           .find(".collectionAtc")
  //           .removeClass("checked_cart");
  //       } else {
  //         $(this).parents(".product-form__input").addClass("checked_option");
  //         $(this).parents(".product_form").find(".list_hidden_id").val(varid);
  //         $(this)
  //           .parents(".product_form")
  //           .find(".collectionAtc")
  //           .val("Add to Cart")
  //           .removeAttr("disabled", "disabled");

  //         $(this)
  //           .parents(".product-index")
  //           .find(".prod-image img")
  //           .attr("data-srcset", varimg);
  //         $(this)
  //           .parents(".product-index")
  //           .find(".prod-image img")
  //           .attr("srcset", varimg);
  //         $(this)
  //           .parents(".product-index")
  //           .find(".price--listing .price-item--regular")
  //           .text(reg_price);
  //         $(this)
  //           .parents(".product-index")
  //           .find(".collectionAtc")
  //           .addClass("checked_cart");
  //       }
  //       var option1 = selectedDevice;
  //       var option2 = selectedCase;
  //       var combination2 = option1 + " / " + option2;
  //       $(this)
  //         .parents(".product-index")
  //         .find(".no-js-hide-selectbox option")
  //         .each(function () {
  //           var option_value = $(this).text().trim();
  //           possibles2.push(option_value);
  //         });
  //       console.log(possibles2);
  //       $(this)
  //         .parents(".product-index")
  //         .find(
  //           ".collection_swatches.swatches__container.js-variant-selector input"
  //         )
  //         .each(function () {
  //           var option2_flag = false;
  //           var option2_val = $(this).val();
  //           var combination4 = option2_val + " / " + option1;
  //           var final_comb = combination4.trim();
  //           possibles2.forEach((variant) => {
  //             if (variant.includes(final_comb)) {
  //               option2_flag = true;
  //             }
  //           });
  //           if (option2_flag === false) {
  //             $(this).next().parent().addClass("soldout");
  //           } else {
  //             $(this).next().parent().removeClass("soldout");
  //           }
  //         });
  //     });

  //     clearInterval(interval);
  //   }
  // }, 10);

  /*
   * altbased closed function
   */
  // $(document).on("change", ".cstm_collecto", function () {
  //   var cstmcollval = $(this).find(":selected").val();
  //   var currUrl = $(this).find(":selected").attr("data-url");

  //   $(this).parents(".span-3").find("a").attr("href", currUrl);
  //   if (cstmcollval != "Select a Device") {
  //     //alert('1');
  //     var colnewVala = cstmcollval
  //       .toLowerCase()
  //       .replace(/[^a-z0-9]+/g, "-")
  //       .replace(/-$/, "")
  //       .replace(/^-/, "");
  //     var cimgsrca = $(this)
  //       .parents(".span-3")
  //       .find(".variants_hidedimgs")
  //       .find("." + colnewVala)
  //       .attr("src");

  //     var secondImagea = $(this)
  //       .parents(".span-3")
  //       .find(".variants_hidedimgs")
  //       .find("." + colnewVala + ":eq(1)")
  //       .attr("src");

  //     if (secondImagea != undefined) {
  //       //alert('2');
  //       var ccustmHTMLa = '<img src="' + secondImagea + '"> ';
  //       $(this).parents(".span-3").find(".cstm_hidden").html(ccustmHTMLa);
  //       $(this)
  //         .parents(".span-3")
  //         .find(".cstm_mainimmgrnd")
  //         .attr("data-srcset", cimgsrca);
  //       $(this)
  //         .parents(".span-3")
  //         .find(".cstm_mainimmgrnd")
  //         .attr("srcset", cimgsrca);

  //       setTimeout(function () {
  //         $(".cstm_hidden").children("img").removeAttr("data-srcset");
  //         $(".cstm_hidden").children("img").removeAttr("srcset");
  //       }, 1000);
  //     } else {
  //       //alert('3');

  //       var cimgsrctext = $(this)
  //         .parents(".span-3")
  //         .find(".js-product-details-link")
  //         .children("h3")
  //         .text();
  //       var cimgsrctextval = cimgsrctext
  //         .toLowerCase()
  //         .replace(/[^a-z0-9]+/g, "-")
  //         .replace(/-$/, "")
  //         .replace(/^-/, "");
  //       //    alert(cimgsrctextval);
  //       var cimgsecondImage = $(this)
  //         .parents(".span-3")
  //         .find(".variants_hidedimgs")
  //         .find("." + cimgsrctextval + ":eq(1)")
  //         .attr("src");
  //       if (cimgsecondImage != undefined) {
  //         // alert('4');

  //         var cimcustmHTMLl = '<img src="' + cimgsecondImage + '">';
  //         $(this).parents(".span-3").find(".cstm_hidden").html(cimcustmHTMLl);
  //       } else {
  //         //  alert('5');
  //         var eleimg = $(this)
  //           .parents(".span-3")
  //           .find(".variants_hidedimgs")
  //           .children("img:eq(1)")
  //           .attr("src");
  //         var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //         $(this).parents(".span-3").find(".cstm_hidden").html(cimcustmHTMLl22);
  //       }
  //     }
  //   } else {
  //     // alert('6');
  //     var cimgsrctext = $(this)
  //       .parents(".span-3")
  //       .find(".js-product-details-link")
  //       .children("h3")
  //       .text();
  //     var cimgsrctextval = cimgsrctext
  //       .toLowerCase()
  //       .replace(/[^a-z0-9]+/g, "-")
  //       .replace(/-$/, "")
  //       .replace(/^-/, "");
  //     var cimgsecondImage = $(this)
  //       .parents(".span-3")
  //       .find(".variants_hidedimgs")
  //       .find("." + cimgsrctextval + ":eq(2)")
  //       .attr("src");

  //     //       var cimcustmHTMLl = '<img src="'+cimgsecondImage+'"> ';
  //     //    $(this).parents('.span-3').find('.cstm_hidden').html(cimcustmHTMLl);

  //     //    $(this).parents('.span-3').find('.cstm_mainimmgrnd').attr('data-srcset',cimgsrca);
  //     //    $(this).parents('.span-3').find('.cstm_mainimmgrnd').attr('srcset',cimgsrca);

  //     if (cimgsecondImage != undefined) {
  //       // alert('7');
  //       var cimcustmHTMLl = '<img src="' + cimgsecondImage + '"> ';
  //       $(this).parents(".span-3").find(".cstm_hidden").html(cimcustmHTMLl);

  //       $(this)
  //         .parents(".span-3")
  //         .find(".cstm_mainimmgrnd")
  //         .attr("data-srcset", cimgsrc);
  //       $(this)
  //         .parents(".span-3")
  //         .find(".cstm_mainimmgrnd")
  //         .attr("srcset", cimgsrc);
  //     } else {
  //       //alert('8');
  //       var eleimg = $(this)
  //         .parents(".span-3")
  //         .find(".variants_hidedimgs")
  //         .children("img:eq(1)")
  //         .attr("src");
  //       var cimcustmHTMLl22 = '<img src="' + eleimg + '"> ';
  //       $(this).parents(".span-3").find(".cstm_hidden").html(cimcustmHTMLl22);
  //     }
  //   }
  // });
  //    setTimeout(function(){

  $(".reveal").hover(function () {
    $(this).toggleClass("collmain_active");
  });
  //    },2000);

  $(".inner_secodlevel").hover(function () {
    $(".inner_secodlevel").removeClass("inner_active");
    $(this).addClass("inner_active");
    var cstmatr = $(this).attr("data-attr");
    $(".third_label_str")
      .children(".megamenu__list")
      .removeClass("inner_active");
    $(".third_label_str")
      .children("." + cstmatr)
      .addClass("inner_active");
  });

  $(".collables_mainli").hover(function () {
    $(".collables_mainli").removeClass("collab2_active");
    $(this).addClass("collab2_active");
  });

  $(".option__swatches_name_select-a-case-type .swatches__form--input").change(
    function () {
      var get_val = $(this).val();
      $(".option_dropdown_name_select-a-case-type select")
        .val(get_val)
        .trigger("change");
    }
  );
  $(document).on("click", ".checkout_btn a", function (e) {
    e.preventDefault();
    var ID = $("input.formVariantId").val();
    var quanity = $("input.formQty").val();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quanity,
        id: ID,
      },
      dataType: "json",
      success: function (data) {
        document.location.href = "/checkout";
      },
    });
  });
  //$('.collection_select_options').prepend('<option value="Select a Device" selected="selected">Select a Device</option>');

  // $(".product-index").each(function () {
  //   var selectedDevice = $(this)
  //     .find(".collection_select_options option:selected")
  //     .val();
  //   var selectedCase = $(this).find(".collection_swatches input:checked").val();
  //   var selectedValues = selectedCase + " / " + selectedDevice;
  //   console.log(selectedValues);
  //   var varid = $(this)
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("varid");
  //   var varimg = $(this)
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("var_img");
  //   if (selectedDevice != "Select a Device") {
  //     $(this).find(".collectionAtc").removeAttr("disabled", "disabled");
  //     $(this).find("option:first-child").attr("disabled", "disabled");
  //   }
  //   if (typeof varid === "undefined") {
  //     //$(this).find('.collectionAtc').val('Unavailable').attr('disabled','disabled');
  //   } else {
  //     $(this).find(".list_hidden_id").val(varid);
  //     $(this)
  //       .find(".collectionAtc")
  //       .val("Add to Cart")
  //       .removeAttr("disabled", "disabled");

  //     $(this).find(".prod-image img").attr("data-srcset", varimg);
  //     $(this).find(".prod-image img").attr("srcset", varimg);
  //   }
  // });
  // $(".collection_select_options").change(function () {
  //   var possibles2 = [];
  //   $(this).find("option:first-child").attr("disabled", "disabled");
  //   var selectedDevice = $(this).find("option:selected").val();
  //   var selectedCase = $(this)
  //     .parents(".product-index")
  //     .find(".collection_swatches input:checked")
  //     .val();
  //   var selectedValues = selectedCase + " / " + selectedDevice;
  //   var varid = "";

  //   varid = $(this)
  //     .parents(".product_form")
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("varid");
  //   var price = $(this)
  //     .parents(".product_form")
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("reg_price");
  //   var varimg = $(this)
  //     .parents(".product_form")
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("var_img");
  //   var reg_price = $(this)
  //     .parents(".product_form")
  //     .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //     .attr("reg_price");

  //   console.log(varid);
  //   if (typeof varid === "undefined") {
  //     $(this).removeClass("checked_option");
  //     $(this)
  //       .parents(".product_form")
  //       .find(".collectionAtc")
  //       .val("Unavailable")
  //       .attr("disabled", "disabled");
  //     $(this)
  //       .parents(".product-index")
  //       .find(".collectionAtc")
  //       .removeClass("checked_cart");
  //   } else {
  //     $(this).parents(".product-form__input").addClass("checked_option");
  //     $(this).parents(".product_form").find(".list_hidden_id").val(varid);
  //     $(this)
  //       .parents(".product_form")
  //       .find(".collectionAtc")
  //       .val("Add to Cart")
  //       .removeAttr("disabled", "disabled");

  //     $(this)
  //       .parents(".product-index")
  //       .find(".prod-image img")
  //       .attr("data-srcset", varimg);
  //     $(this)
  //       .parents(".product-index")
  //       .find(".prod-image img")
  //       .attr("srcset", varimg);
  //     $(this)
  //       .parents(".product-index")
  //       .find(".price--listing .price-item--regular")
  //       .text(reg_price);
  //     $(this)
  //       .parents(".product-index")
  //       .find(".collectionAtc")
  //       .addClass("checked_cart");
  //   }
  //   var option1 = selectedDevice;
  //   var option2 = selectedCase;
  //   var combination2 = option1 + " / " + option2;
  //   $(this)
  //     .parents(".product-index")
  //     .find(".no-js-hide-selectbox option")
  //     .each(function () {
  //       var option_value = $(this).text().trim();
  //       possibles2.push(option_value);
  //     });
  //   console.log(possibles2);
  //   $(this)
  //     .parents(".product-index")
  //     .find(
  //       ".collection_swatches.swatches__container.js-variant-selector input"
  //     )
  //     .each(function () {
  //       var option2_flag = false;
  //       var option2_val = $(this).val();
  //       var combination4 = option2_val + " / " + option1;
  //       var final_comb = combination4.trim();
  //       possibles2.forEach((variant) => {
  //         if (variant.includes(final_comb)) {
  //           option2_flag = true;
  //         }
  //       });
  //       if (option2_flag === false) {
  //         $(this).next().parent().addClass("soldout");
  //       } else {
  //         $(this).next().parent().removeClass("soldout");
  //       }
  //     });
  // });

  // $(document).on("click", ".collection_swatches label", function (e) {
  //   e.preventDefault();
  //   $(this).prev().click();
  //   var varid = "";
  //   var varimg = $(this).prev().attr("var_img");
  //   var selectedCase = $(this).prev().val();
  //   var nameval = $(this).prev().attr("name");
  //   var price = $(this).prev().attr("reg_price");
  //   //console.log(selectedCase);
  //   $(this)
  //     .parents(".product-index")
  //     .find(".price--listing .price-item--regular")
  //     .text(price);
  //   $('.collection_swatches input[name="' + nameval + '"]').removeAttr(
  //     "checked",
  //     "checked"
  //   );
  //   $(this).prev().attr("checked", "checked");
  //   var selectedDevice = $(this)
  //     .parents(".product-index")
  //     .find(".collection_select_options option:selected")
  //     .val();

  //   var selectedValues = selectedCase + " / " + selectedDevice;

  //   if (selectedDevice != "Select a Device") {
  //     varid = $(this)
  //       .parents(".product-index")
  //       .find('.hidden_dropdown_options option[value="' + selectedValues + '"]')
  //       .attr("varid");
  //     if (typeof varid === "undefined") {
  //       $(this)
  //         .parents(".product-index")
  //         .find(".collectionAtc")
  //         .val("Unavailable")
  //         .attr("disabled", "disabled");
  //     } else {
  //       $(this).parent().removeClass("soldout");
  //       $(this).parents(".product-index").find(".list_hidden_id").val(varid);
  //       $(this)
  //         .parents(".product-index")
  //         .find(".collectionAtc")
  //         .val("Add to Cart")
  //         .removeAttr("disabled", "disabled");
  //     }
  //   }
  //   $(this)
  //     .parents(".product-index")
  //     .find(".prod-image img")
  //     .attr("data-srcset", varimg);
  //   $(this)
  //     .parents(".product-index")
  //     .find(".prod-image img")
  //     .attr("srcset", varimg);
  // });

  // $(document).on("click", ".slidecarthq button", function () {
  //   $("body").removeClass("slideout-right--open");
  //   $("body").addClass("slideout-right--closed");
  //   $("body").removeAttr("style");
  // });
  $("body").click(function () {
    $(this).removeClass("slideout-right--open");
    $(this).addClass("slideout-right--closed");
    $(this).removeAttr("style");
    $("body").css("overflow", "auto");
  });
});

$(window).on("load", function () {
  $(".star-clickable").click(function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $(".yotpo-product-container").offset().top - 100,
      },
      2000
    );
    return false;
  });
  if ($(window).width() < 768) {
    $(".yotpo-bottomline a").each(function () {
      var text = $(this).text();
      if (text.indexOf("Write") > -1) {
      } else {
        $(this).text(text.replace("Review", ""));
        var currenttext = $(this).text();
        $(this).text("(" + currenttext + ")");
        var str = $(this).text();
        var rep = str.replace(/\s/g, "");
        $(this).text(rep);
      }
    });
  }
});
